import axios from "axios";
import { CODE_VERSION } from "@/env.ts";

const getHeaders = () => {
  return { "Code-Version": `WEB-${CODE_VERSION}`, Platform: "Web" };
};
export const CONTENT_BASE_URL = "https://content.vidapp.com";
export const USER_BASE_URL = "https://user.vidapp.com";
export const client = axios.create({
  headers: getHeaders(),
});

const JWT_URLS = [CONTENT_BASE_URL, USER_BASE_URL];
client.interceptors.request.use(
  (config) => {
    // Do not override auth header for `auth/token/refresh` endpoint as that API call is made using httponly refresh cookie
    if (config.url === "auth/token/refresh") return config;
    if (JWT_URLS.find((url) => config.url?.startsWith(url))) {
      // Specified domains need JWT
      if (config.url?.includes("tunnel") && config.url?.endsWith("/open")) {
        // Open tunnel does not need JWT
        return config;
      }
    } else if (
      config.url?.startsWith("https://") ||
      config.url?.startsWith("http://")
    ) {
      // Other External APIs don't need JWT
      return config;
    }

    config.headers["Authorization"] = `Bearer ${localStorage.getItem("jwt")}`;
    return config;
  },
  (error) => {
    Promise.reject(error);
  },
);
